import { render, staticRenderFns } from "./PatientModalMovePatient.vue?vue&type=template&id=8a543528"
import script from "./PatientModalMovePatient.vue?vue&type=script&lang=js"
export * from "./PatientModalMovePatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports